<template>
  <form @submit.prevent>
    <h6 class="heading-small text-muted mb-4">{{ $t("update_password") }}</h6>
    <div class="">
      <div class="row">
        <div class="col-lg-6">
          <base-input
            class="input-group-alternative border"
            :placeholder="$t('password')"
            type="password"
            addon-left-icon="ni ni-lock-circle-open"
            data-vv-validate-on="blur"
            v-validate="'required|min:8|max:20'"
            :data-vv-as="$t('password')"
            name="password"
            v-model="form.password"
            ref="password"
          >
          </base-input>
          <span class="text-danger text-sm" v-show="errors.has('password')"
            ><small>{{ errors.first("password") }}</small></span
          >
        </div>
        <div class="col-lg-6">
          <base-input
            class="input-group-alternative border"
            :placeholder="$t('password_confirmation')"
            type="password"
            addon-left-icon="ni ni-lock-circle-open"
            v-model="form.password_confirmation"
            data-vv-validate-on="blur"
            v-validate="'required|min:8|max:20|confirmed:password'"
            name="password_confirmation"
            :data-vv-as="$t('password_confirmation')"
          >
          </base-input>
          <span
            class="text-danger text-sm"
            v-show="errors.has('password_confirmation')"
            ><small>{{ errors.first("password_confirmation") }}</small></span
          >
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <base-button type="primary" class="my-4" @click="updatePassword">{{
          $t("update")
        }}</base-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    data () {
        return {
            form: {
                password: '',
                password_confirmation: ''
            }
        }
    },
    methods: {
        async updatePassword () {
            const validation = await this.$validator.validateAll()
            if (validation) {
                const res = await this.updatePasswordUser(this.form)
                this.$toast.success( res.message, {
                    position: 'top-right'
                })
            }
        },
        ...mapActions({
            updatePasswordUser: 'auth/updatePassword'
        })
    }
};
</script>

<style></style>
